<script>
export default {
  name: 'UserManage',
  data() {
    return {
      filter: {
        email: '',
        limit: null,
        current_page: null,
        roles: null,
      },

      items: {
        users: [],
      },

      options: {
        roles: [
          {value: 'is_none', text: 'Пользователь'},
          {value: 'is_admin', text: 'Администратор'},
          {value: 'is_manager', text: 'Контент-менеджер'},
        ],
      },

      form: {
        id: null,
        email: '',
        first_name: '',
        last_name: '',
        middle_name: '',
        region: '',
        company: '',
        telephone: '',
        role: 'is_none',
        email_text:
          'Вы зарегистрированы в системе VRKTPP.ru. ' +
          'Добро пожаловать на виртуальную выставку Союза «Калининградская торгово-промышленная палата». ' +
          'Это письмо сформировано автоматически.',
      },

      fields: {
        users: [
          {
            key: 'email',
            label: 'Логин (e-mail)',
            class: 'align-middle',
          },
          {
            key: 'last_name',
            label: 'Фамилия',
            class: 'align-middle',
          },
          {
            key: 'first_name',
            label: 'Имя',
            class: 'align-middle',
          },
          {
            key: 'middle_name',
            label: 'Отчество',
            class: 'align-middle',
          },
          {
            key: 'roles',
            label: 'Роль',
            class: 'align-middle',
          },
          {
            key: 'actions',
            label: 'Действия',
            class: 'actions align-middle text-center',
          },
        ],
      },

      errors: {},

      pagination: {
        current_page: 1,
        from: null,
        last_page: null,
        path: null,
        per_page: null,
        to: null,
        total: null,
      },
    }
  },
  watch: {
    'filter.email'(newValue) {
      this.fetchUsers()
    },
  },
  computed: {
    getPagination() {
      let pagination
      pagination = this.pagination
      return pagination
    },
    getUsers() {
      return this.items.users
    },
    getFields() {
      let fields = this.fields.users.filter((item) => {
        if (this.filter.roles === 'manage') {
          return true
        } else {
          return item.key !== 'roles'
        }
      })
      return fields
    },
    getTitle() {
      if (this.filter.roles === 'manage') {
        return 'Пользователи панели администрирования'
      } else {
        return 'Пользователи клиентского приложения'
      }
    },
    getTitleForm() {
      if (this.form.id >= 1) {
        return 'Редактирование данных пользователя'
      } else {
        return 'Добавление нового пользователя'
      }
    },
    getTitleFormSubmit() {
      if (this.form.id >= 1) {
        return 'Сохранить'
      } else {
        return 'Добавить'
      }
    },
    roleOptions() {
      return this.options.roles
    },
  },
  methods: {
    fetchUsers() {
      axios
        .get('/webapi/user', {
          params: this.filter,
        })
        .then(({data}) => {
          this.items.users = data.data
        })
    },
    gerRoleName(user) {
      if (user.is_admin) {
        return 'Администратор'
      } else if (user.is_manager) {
        return 'Контент-менеджер'
      }
      return 'Пользователь'
    },
    userEdit(userId) {
      this.errors = {}
      this.$bvModal.show('modal-user-form')
      axios.get(`/webapi/user/${userId}`).then(({data}) => {
        Object.assign(this.form, data.data)
        if (this.form.is_admin) {
          this.form.role = 'is_admin'
        } else if (this.form.is_manager) {
          this.form.role = 'is_manager'
        } else {
          this.form.role = 'is_none'
        }
      })
    },
    userAdd() {
      Object.assign(this.form, {
        id: null,
        email: '',
        first_name: '',
        last_name: '',
        middle_name: '',
        region: '',
        company: '',
        telephone: '',
        role: 'is_none',
      })
      this.errors = {}
      this.$bvModal.show('modal-user-form')
    },
    userSave() {
      let params = {
        first_name: this.form.first_name,
        last_name: this.form.last_name,
        middle_name: this.form.middle_name,
      }
      if (this.form.role === 'is_admin') {
        params.is_admin = true
        params.is_manager = false
      } else if (this.form.role === 'is_manager') {
        params.is_manager = true
        params.is_admin = false
      }
      params.region = this.form.region
      params.company = this.form.company
      params.telephone = this.form.telephone
      params.email_text = this.form.email_text

      let userRequest

      if (this.form.id >= 1) {
        userRequest = axios.put(`/webapi/user/${this.form.id}`, params)
      } else {
        params.email = this.form.email
        userRequest = axios.post(`/webapi/user`, params)
      }
      userRequest
        .then(() => {
          this.makeToast('Успешно', 'success')
          this.$bvModal.hide('modal-user-form')
          this.fetchUsers()
        })
        .catch(({response}) => {
          this.errors = response.data.errors
          for (const responseKey in this.errors) {
            this.makeToast(this.errors[responseKey][0], 'danger')
          }
          if (response.data.message) {
            if (response.data.message !== 'The given data was invalid.') {
              this.makeToast(response.data.message, 'danger', 'Ошибка')
            }
          }
        })
    },
    userDelete(userId) {
      this.boxTwo = ''
      this.$bvModal
        .msgBoxConfirm('Действительно удалить пользователя?', {
          title: 'Подтверждение удаления пользователя',
          size: 'md',
          buttonSize: 'md',
          okVariant: 'danger',
          okTitle: 'Удалить',
          cancelTitle: 'Отменить',
          hideHeaderClose: true,
          centered: true,
          bodyClass: 'h5',
          titleClass: 'font-weight-bold',
          headerClass: 'border-bottom-0',
          footerClass: 'border-top-0',
        })
        .then((value) => {
          this.boxTwo = value
          if (this.boxTwo) {
            axios
              .delete(`/webapi/user/${userId}`)
              .then(() => {
                this.makeToast('Пользователь удален', 'success')
                this.fetchUsers()
              })
              .catch(() => this.makeToast('Ошибка удаления пользователя', 'danger'))
          }
        })
        .catch((err) => {
          // An error occurred
        })
    },
    userPasswordReset(user) {
      this.boxTwo = ''
      this.$bvModal
        .msgBoxConfirm(`На почту ${user.email} будет отправлено уведомление и инструкция для восстановления пароля`, {
          title: 'Действительно отправить уведомление?',
          size: 'md',
          buttonSize: 'md',
          okVariant: 'primary',
          okTitle: 'Уведомить',
          cancelTitle: 'Отменить',
          hideHeaderClose: true,
          centered: true,
          bodyClass: 'h5',
          titleClass: 'font-weight-bold',
          headerClass: 'border-bottom-0',
          footerClass: 'border-top-0',
        })
        .then((value) => {
          this.boxTwo = value
          if (this.boxTwo) {
            axios
              .post(`/webapi/user/reset/password`, {
                email: user.email,
              })
              .then(() => {
                this.makeToast('Уведомление отправлено', 'success')
                this.$bvModal.hide('modal-user-form')
                this.fetchUsers()
              })
              .catch(({response}) => {
                this.errors = response.data.errors
              })
          }
        })
        .catch((err) => {
          // An error occurred
        })
    },
    makeToast(body = 'Ничего не произошло', variant = 'warning', title = 'Уведомление') {
      this.$bvToast.toast(body, {
        title: title,
        autoHideDelay: 9000,
        appendToast: false,
        variant: variant,
        toaster: 'b-toaster-bottom-center',
      })
    },
    userUpdateStatus(userId, status) {
      this.boxTwo = ''
      let text_1 = ''
      let text_2 = ''
      let text_3 = ''
      let url = ''
      if (status === 'activate') {
        text_1 = 'разблокировки'
        text_2 = 'разблокировать'
        text_3 = 'Разблокировать'
        url = `/webapi/user/${userId}/activated`
      } else {
        text_1 = 'блокировки'
        text_2 = 'заблокировать'
        text_3 = 'Заблокировать'
        url = `/webapi/user/${userId}/deactivated`
      }

      this.$bvModal
        .msgBoxConfirm(`Действительно ${text_2} пользователя?`, {
          title: `Подтверждение ${text_1} пользователя`,
          size: 'md',
          buttonSize: 'md',
          okVariant: 'primary',
          cancelVariant: 'secondary',
          okTitle: text_3,
          cancelTitle: 'Отменить',
          hideHeaderClose: true,
          centered: true,
          bodyClass: 'h5',
          titleClass: 'font-weight-bold',
          headerClass: 'border-bottom-0',
          footerClass: 'border-top-0',
        })
        .then((value) => {
          this.boxTwo = value
          if (this.boxTwo) {
            axios.put(url).then(() => {
              this.fetchUsers()
            })
          }
        })
        .catch((err) => {
          // An error occurred
        })
    },
  },
  created() {
    this.filter.roles = new URL(location.href).searchParams.get('roles')
    this.fetchUsers()
  },
}
</script>
